import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectskalpataru } from "../../../../data/projects/kalpataru/data";
import { projectsrustomjee } from "../../../../data/projects/Rustomjee/data";

export const RustomjeeBayView = () => {
  const {
    rustomjeebayview: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsrustomjee;

  return (
    <>
      <Helmet>
        <title>Rustomjee 180 Bayview, Matunga West, Mumbai | Luxury Sea-View Apartments</title>

        <meta
          name="description"
          content="Explore Rustomjee 180 Bayview in Matunga West, Mumbai, offering premium sea-view apartments with world-class amenities. Experience luxury living in a prime location."
        />

        <meta
          name="keywords"
          content="Rustomjee 180 Bayview, Rustomjee 180 Bayview Matunga, luxury apartments Matunga West, sea-view apartments Mumbai, Rustomjee Matunga West, Rustomjee Mumbai real estate, premium residences Matunga, luxury living Mumbai, sea-view luxury apartments Mumbai"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/rustomjee-180-bayview-matunga-west-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
